/**
 * Einheitliches Fehler-Popup fuer alle Apps. Zeigt eine oder mehrere Fehlermeldungen
 * lesbar (umbrechend, scrollbar) statt sie in einer schmalen Statuszelle abzuschneiden,
 * und bietet „Als JSON kopieren" fuer den Support. Baut auf openModal auf.
 *
 *   openErrorModal({
 *     title: 'Fehler beim Speichern',
 *     items: [{ label: 'ABC123-s-red', message: 'Vario 422: Pflichtfeld fehlt — currencyRef' }],
 *     json: rawServerResponse,   // optional; Default = items
 *   });
 */
import { openModal } from './modal.js';
function esc(s) {
    return String(s)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
}
export function openErrorModal(opts) {
    const items = opts.items ?? [];
    // Vollstaendiges Debug-Envelope: alles, was der Support zum Nachstellen braucht.
    const payload = {
        capturedAt: new Date().toISOString(),
        title: opts.title ?? 'Fehler',
        url: typeof location !== 'undefined' ? location.href : undefined,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
        messages: items,
        context: opts.context,
        detail: opts.json,
    };
    const jsonText = JSON.stringify(payload, null, 2);
    const listHtml = items
        .map((it) => `
      <div style="padding:8px 0;border-bottom:1px solid var(--go-border,#e5e7eb);">
        ${it.label ? `<div style="font-weight:600;font-size:13px;margin-bottom:2px;">${esc(it.label)}</div>` : ''}
        <div style="font-size:13px;line-height:1.45;white-space:pre-wrap;word-break:break-word;color:var(--go-danger,#c0392b);">${esc(it.message)}</div>
      </div>`)
        .join('');
    const body = `
    ${opts.intro ? `<p class="v-text-muted" style="margin:0 0 8px;font-size:13px;">${esc(opts.intro)}</p>` : ''}
    <div style="max-height:50vh;overflow:auto;">${listHtml}</div>`;
    const footer = `
    <button type="button" class="v-button v-button--ghost" data-error-copy><span class="v-icon fa-regular fa-copy"></span> Als JSON kopieren</button>
    <button type="button" class="v-button v-button--primary" data-modal-cancel>Schließen</button>`;
    const modal = openModal({ title: opts.title ?? 'Fehler', icon: 'fa-triangle-exclamation', width: 600, body, footer });
    const copyBtn = modal.el.querySelector('[data-error-copy]');
    copyBtn?.addEventListener('click', () => {
        void navigator.clipboard?.writeText(jsonText);
        const orig = copyBtn.innerHTML;
        copyBtn.innerHTML = '<span class="v-icon fa-regular fa-check"></span> Kopiert';
        window.setTimeout(() => { copyBtn.innerHTML = orig; }, 1500);
    });
    return modal;
}
//# sourceMappingURL=error-modal.js.map